<template>
    <div>
        <van-nav-bar
                title="账单"
                left-arrow
                class="my-nav"
                :fixed="true"
                @click-left="$router.back(-1)"
        />

        <div class="body">
            <ul class="jinyijia-cells">
                <li class="jinyijia-cell" v-for="bill in billsInfoArray" :key="bill.code">
                    <div>
                        <van-icon :name="bill.info.icon" class="icon" :style="{background: bill.info.color}"></van-icon>
                    </div>
                    <div>
                        <div>
                            <div>{{bill.type}} <small v-if="bill.remark">({{bill.remark}})</small></div>
                            <p v-text="bill.wallet.shopName">订单</p>
                            <p style="color:#999" v-text="bill.createTime">今天 09:00</p>
                        </div>
                        <div class="money" v-text="bill.amount">-3.00</div>
                    </div>
                </li>
            </ul>
            <van-divider>暂无更多</van-divider>
        </div>
    </div>
</template>

<script>
    import {getBillsInfo} from "../../api/balance";

    export default {
        data() {
            return {
                billsInfoArray: []
            };
        },
        mounted() {
            getBillsInfo(data => {
                this.billsInfoArray = data.map(d => {
                    d.amount = parseFloat(d.amount / 100).toFixed(2);
                    d.amount = this.type2info(d.type).prefix+ d.amount;
                    d.info = this.type2info(d.type)
                    return d;
                });
            });
        },
        methods: {
            type2info(type) {
                let o = {
                    '充值': {icon: 'gold-coin', color: '#ffa028', prefix: '+'},
                    '支付': {icon: 'checked', color: '#ff3038', prefix: '-'},
                    '订单取消': {icon: 'clear', color: '#ff6028', prefix: '+'},
                    '返利抵扣': {icon: 'gift', color: '#ffa028', prefix: '+'},
                    '价保抵扣': {icon: 'gift', color: '#ffa028', prefix: '+'},
                    '预售解冻': {icon: 'label', color: '#ffa028', prefix: '+'},
                    '预售冻结': {icon: 'send-gift', color: '#ff3038', prefix: '-'},
                    '扣罚款': {icon: 'label', color: '#ff0008', prefix: '-'},
                    '三方支付充值': {icon: 'card', color: '#ffa028', prefix: '+'},
                    '中行打款': {icon: 'card', color: '#ffa028', prefix: '+'},
                    '线下订单支付': {icon: 'cart', color: '#ff3038', prefix: '-'},
                    '预售订单支付': {icon: 'label', color: '#ff3038', prefix: '-'},
                }
                // console.log(type,o[type])
                return o[type]
            }
        }
    };
</script>

<style lang="less" scoped>
    .body {
        margin: 60px 0;
    }

    .jinyijia-cells {
        padding: 15px;
    }

    .icon {
        width: 30px;
        height: 30px;
        font-size: 20px;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        color: #fff;
    }

    .money {
        font-size: 15px;
        font-weight: bold;
    }

    .jinyijia-cell {

        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        text-align: left;

        div {
            flex-basis: auto;
        }

        & > div:first-child {
            width: 50px;
        }

        & > div:last-child {
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            border-bottom: 1px solid #eee;

            p {
                font-size: 12px;
            }
        }
    }

    .van-cell {
        color: #ffa028;
    }
</style>
